import { useState } from "react";
import { Send, User, X } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { emptyForm, validateForm } from "@/components/Contact";
import { EnquiryFields } from "@/components/Contact";

export default function QuoteModal({ presetProduct = "", onClose }) {
  const [form, setForm] = useState({ ...emptyForm, product: presetProduct });
  const [sending, setSending] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    const err = validateForm(form);
    if (err) {
      toast.error(err);
      return;
    }
    setSending(true);
    try {
      const res = await api.post("/enquiries", form);
      toast.success(res.data.message || "Enquiry received. Our team will contact you shortly.");
      onClose();
    } catch (e2) {
      toast.error(formatApiErrorDetail(e2.response?.data?.detail) || "Failed to submit enquiry. Please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[70] flex items-end sm:items-center justify-center bg-black/50 backdrop-blur-sm p-0 sm:p-4" onClick={onClose} data-testid="quote-modal-overlay">
      <div
        className="bg-white w-full sm:max-w-2xl max-h-[92vh] overflow-y-auto rounded-t-2xl sm:rounded-2xl shadow-2xl"
        onClick={(e) => e.stopPropagation()}
        data-testid="quote-modal"
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-medis-silver/20 sticky top-0 bg-white z-10 rounded-t-2xl">
          <div className="flex items-center gap-2 text-[11.5px] uppercase tracking-[0.22em] text-medis-teal font-semibold">
            <User className="h-3.5 w-3.5" /> Enquiry Form
          </div>
          <button onClick={onClose} className="h-8 w-8 flex items-center justify-center rounded-full hover:bg-medis-subtle transition-colors" data-testid="quote-modal-close" aria-label="Close">
            <X className="h-4 w-4 text-medis-gray" />
          </button>
        </div>
        <form className="p-6 sm:p-8" onSubmit={onSubmit}>
          <h3 className="font-display font-bold text-medis-navy text-2xl leading-tight tracking-tight">Tell us about your requirement.</h3>
          <EnquiryFields form={form} setForm={setForm} testPrefix="quote" />
          <div className="mt-6 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
            <p className="text-[12px] text-medis-gray leading-snug max-w-xs">
              By submitting, you agree to be contacted by MEDIS Group LLP. We respect your data.
            </p>
            <button
              type="submit"
              className="inline-flex items-center justify-center gap-2 bg-medis-blue text-white px-6 py-3.5 rounded-md text-[14px] font-semibold hover:bg-medis-blue-dark transition-colors disabled:opacity-70"
              disabled={sending}
              data-testid="quote-modal-submit"
            >
              {sending ? "Submitting…" : "Submit Enquiry"}
              <Send className="h-4 w-4" />
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
